import type {PromotionTool} from 'modules/Services/PromotionCenter/types';

import {useNavigate} from 'react-router-dom';

import PromotionToolCard from './components/PromotionToolCard/PromotionToolCard';

type PromotionToolsGridProps = {
  tools: PromotionTool[];
};

const PromotionToolsGrid: React.FC<PromotionToolsGridProps> = ({tools}) => {
  const navigate = useNavigate();

  return (
    <section className="px-4 pb-4" aria-labelledby="promotion-tools-title">
      <h1 className="my-4 text-subtitle-md text-neutral-fg" id="promotion-tools-title">
        ابزارهای افزایش فروش
      </h1>
      <div className="grid grid-cols-2 gap-4">
        {tools.map((tool) => (
          <PromotionToolCard key={tool.id} tool={tool} onClick={() => navigate(tool.path)} />
        ))}
      </div>
    </section>
  );
};

export default PromotionToolsGrid;
